/* CRO global scripts: honest countdowns, announcement rotator. No dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Countdown (real time left until data-end, ms epoch) ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var now = Date.now();
    $$('[data-cro-countdown]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-end'), 10);
      var left = end - now;
      if (!end || left <= 0) {
        var wrap = el.closest ? el.closest('[data-cro-deadline]') : null;
        if (wrap) {
          var t = wrap.getAttribute('data-expired');
          wrap.textContent = t ? '🎄 ' + t : '';
          wrap.removeAttribute('data-cro-deadline');
        } else {
          var done = el.getAttribute('data-done-text');
          if (done) { el.textContent = done; el.removeAttribute('data-cro-countdown'); } else { el.parentNode && el.parentNode.removeChild(el); }
        }
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    });
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- Announcement bar rotator ---------- */
  $$('[data-cro-rotator]').forEach(function (bar) {
    var timer = null;
    function msgs() { return $$('.cro-msg', bar); }
    function next() {
      var list = msgs();
      if (list.length < 2) { return; }
      var i = 0;
      list.forEach(function (m, idx) { if (m.classList.contains('is-on')) { i = idx; } });
      list[i].classList.remove('is-on');
      list[(i + 1) % list.length].classList.add('is-on');
    }
    function start() { if (!reduce && !timer) { timer = setInterval(next, 4500); } }
    function stop() { clearInterval(timer); timer = null; }
    start();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
  });
})();
